import { render, staticRenderFns } from "./Roster_List.vue?vue&type=template&id=b51ed90a&scoped=true&"
import script from "./Roster_List.vue?vue&type=script&lang=js&"
export * from "./Roster_List.vue?vue&type=script&lang=js&"
import style0 from "./Roster_List.vue?vue&type=style&index=0&id=b51ed90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51ed90a",
  null
  
)

export default component.exports